<template>
  <div ref="track" v-track="'c_techportal_66wjvrus'" class="community-mvp w-full">
    <div :class="`community-top-nav ${isCurRoute('mvp-home') ? 'home-nav' : 'other-nav'}`">
      <div class="router">
        <img :src="imageSrc" alt="" class="icon" @click="jump('mvp-home')"/>
        <div style="cursor: pointer" class="title" @click="jump('mvp-home')">AGI-Eval</div>
        <!--  -->
        <div
          v-for="router in routerButtonMeta"
          :key="router.title"
          :class="{ 'router-button': true, 'competition-activity': true, active: isCurRoute(router.target) }"
          @click="jump(router.target, router.title)"
        >
          <img v-if="router.title === '人机竞赛'" class="file-img" src="https://p0.meituan.net/llmarena/5876fe351abd9eefc6be350b040b01fd7349.png"/>
          <span :class="{ 'text-background-clip': isCurRoute(router.target) }">{{ router.title }}</span>
        </div>
        <div class="router-button  data-studio" @click="goDataStudio('https://ai-ceping.com/')">
          Data Studio
          <img :src="dataImageSrc" alt="" class="data-studio-img" @click="goDataStudio('https://ai-ceping.com/')"/>
        </div>
      </div>
      <div class="top-right">
        <div class="contribution-evaluation-set flex-center" @click="visible = true">
          <span class="text-background-clip">贡献评测集</span>
        </div>
        <div class="loading-box no-translation-tag">
          <img
            src="https://p0.meituan.net/llmarena/32c9c4080c22847b964c35deb4b8c5741129.png"
            style="width: 22px; margin-right: 10px; cursor: pointer;"
            @click="changeLang"
          />
          <mtd-loading v-if="langLoading" class="loading no-translation-tag" message="" size="small"/>
        </div>
        <i class="mtdicon mtdicon-avatar-fill avatar" @click="goPersonalCenter()" />
      </div>
    </div>
    <mtd-modal v-model="visible" width="390px" class="model-contribution">
      <template #title>
        <div class="text-black text-[28px] font-medium leading-[50px]" style="text-align: center;">贡献评测集</div>
      </template>
      <div class="flex flex-col items-center ">
        <div
          class="text-[#5829fc] text-base font-normal"
          style="padding-left: 2px; color: #595959; font-size: 18px; text-align: center;"
        >
          添加小助手，贡献评测集
        </div>
        <img src="@/assets/evaluation.png" class="w-[200px] h-[200px] mt-[18px]"/>
        <div
          class="text-[#5829fc] text-2xl font-semibold leading-loose text-background-clip"
          style="font-size: 20px; margin: 10px 0"
        >
          AGI-Eval小助手
        </div>
      </div>
    </mtd-modal>
  </div>
</template>
<script lang="ts">
import { postUserMe } from '@/api/modules/user';
import { track } from '@/utils/import-all';
import { changeLang } from '@/utils/translate';
import { Component, Ref, Vue, Watch } from 'vue-property-decorator';
@Component
export default class App extends Vue {
  @Ref('track') trackRef: any;
  routerButtonMeta = [
    {
      title: '评测榜单',
      target: 'mvp-top-Ranking',
    },
    {
      title: '人机竞赛',
      target: 'competition-activity',
    },
    {
      title: '评测集社区',
      target: 'evaluation-home',
    },
  ];
  langLoading = false;
  visible = false;

  @Watch('$store.state.langLoading', { deep: true })
  langLoadingChange(val) {
    this.langLoading = val;
  }

  async changeLang() {
    await new Promise((resolve) => setTimeout(resolve, 0));
    this.$nextTick(async () => {
      await changeLang();
    });
  }

  get imageSrc() {
    return this.isCurRoute('mvp-home')
      ? 'https://p0.meituan.net/llmarena/5fc91621ad2229330963418007fb7ff134140.png'
      : 'https://p0.meituan.net/llmarena/312bf2d7ad4b59e48f94f046ab17560a32914.png';
  }

  get dataImageSrc() {
    return this.isCurRoute('mvp-home')
      ? 'https://p0.meituan.net/llmarena/a794a1c704f7d79a38d337483481e1ac314.png'
      : 'https://p0.meituan.net/llmarena/91dacc5251fc478ebf4a9648b0e48a56298.png';
  }

  goDataStudio(url) {
    track(this.trackRef, 'b_techportal_80urjonw_mc');
    window.open(url);
  }

  jump(target, name?) {
    if (name === '人机比赛') {
      track(this.trackRef, 'b_techportal_o4eqfd3w_mc');
      localStorage.setItem('agi-eval-jump', 'community-top-nav');
      window.open(
        this.$router.resolve({
          name: target,
        }).href,
        '_blank'
      );
    } else {
      this.$route.name !== target && this.$router.push({ name: target });
    }
  }
  isCurRoute(target) {
    return this.$route.name === target;
  }
  async goPersonalCenter() {
    try {
      await postUserMe({});
      this.$router.push({ name: 'mvp-personal-center' });
    } catch (error) {
      // this.$route.name !== 'mvp-login' && this.$router.push({ name: 'mvp-login' });
    }
  }
}
</script>
<style lang="scss" scoped>
.model-contribution {
  ::v-deep {
    .mtd-modal-header {
      padding-top: 20px;
      padding-bottom: 10px;
    }
    .mtd-modal {
      min-width: 380px;
    }
  }
}
.top-right {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255);
  padding: 6px 10px;
  border-radius: 1000px;
  .avatar {
    color: #000 !important;
    font-size: 26px;
  }
  .contribution-evaluation-set {
    color: #4838f3;
    background-color: rgb(241, 240, 254);
    height: 24px;
    padding: 4px 14px;
    font-size: 14px;
    border-radius: 1000px;
    margin-right: 10px;
    cursor: pointer;
  }
}
.loading-box {
  position: relative;
  .loading {
    position: absolute;
    inset: 0;
    transform: translateX(-6px);
  }
}
.competition-activity {
  display: flex;
  align-items: center;
  .file-img {
    width: 20px;
    height: 20px;
  }
}
.community-mvp {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 10;
  min-width: 1280px;
}
.community-top-nav {
  display: flex;
  top: 0;
  height: 60px;
  width: 100%;
  padding: 0 40px;
  align-items: center;
  justify-content: space-between;
}
.home-nav {
  color: white;
  background-color: #000;
  line-height: 36px;
  white-space: nowrap;
  .router{
    &-button:hover {
      background-color:  #4c00ff;
      line-height: 36px;
    }
    .icon {
      width:30px;
      height:30px;
      cursor: pointer;
    }
    .title {
      font-size: 24px;
      margin-left:10px;
    }
  }
}
.other-nav {
  background-color: #fff;
  line-height: 36px;
  white-space: nowrap;
  .router {
    height: 100%;
    .active {
      position: relative;
      line-height: 36px;
      font-weight: 999;
      // border-bottom: 3px solid transparent;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 3px;
        background: linear-gradient(59.67deg, #5f8aff 20.43%, #b428e7 94.21%);
        pointer-events: none; /* 确保伪元素不会干扰鼠标事件 */
      }
    }
    .router-button {
      height: 100%;
      cursor: pointer;
    }
    .icon {
      width:30px;
      height:30px;
      cursor: pointer;
    }
    .title {
      font-size: 24px;
      margin-left:10px;
    }
  }
}
.router {
  display: flex;
  align-items: center;
  &-button {
    height: 36px;
    margin-left: 30px;
    font-size: 18px;
    line-height: 36px;
    border-radius: 20px;
    padding: 0 20px;
    cursor: pointer;
    white-space: nowrap;
  }
}
.avatar {
  cursor: pointer;
  font-size: 30px;
}

.data-studio {
  display: flex;
  align-items: center;
  .data-studio-img {
    width:15px;
    height:15px;
    cursor: pointer;
    margin-left: 5px;
  }
}

</style>
